export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7feb430a2b07e7df929729beaa20c7b17c76fab317&name=fetchTypeahead!'